
import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ProgressCompletionButtonProps {
  isUpdating: boolean;
  enableRpgMode: boolean;
  size: "sm" | "md" | "lg";
  buttonSizeClass: string;
  onComplete: () => void;
}

const ProgressCompletionButton: React.FC<ProgressCompletionButtonProps> = ({
  isUpdating,
  enableRpgMode,
  size,
  buttonSizeClass,
  onComplete
}) => {
  return (
    <div className="flex gap-2">
      <Button
        size="sm"
        variant="default"
        onClick={onComplete}
        disabled={isUpdating}
        className={cn(
          buttonSizeClass,
          enableRpgMode && [
            "bg-amber-600 hover:bg-amber-700 text-white",
            "border border-amber-500/50 shadow-lg",
            "font-montserrat"
          ]
        )}
      >
        {enableRpgMode ? "Reach Destination" : "Mark Unstuck"}
      </Button>
    </div>
  );
};

export default ProgressCompletionButton;
